import type { LobbyGame } from '../api/getLobby';

function dedupeByPickemId(games: LobbyGame[]): LobbyGame[] {
  const seen = new Set<string>();
  const out: LobbyGame[] = [];
  for (const game of games) {
    if (seen.has(game.pickem_id)) continue;
    seen.add(game.pickem_id);
    out.push(game);
  }
  return out;
}

export interface CollectDisplayedLobbyGamesInput {
  hasSectionLayout: boolean;
  sectionGames: LobbyGame[];
  hasAnyFeaturedAssignments: boolean;
  heroCardGames: LobbyGame[];
  actionHeaderGames: LobbyGame[];
  popularSectionGames: LobbyGame[];
  recentlyPlayedSectionGames: LobbyGame[];
  /** Flat layout fallback when no featured slots are assigned. */
  fallbackGames: LobbyGame[];
}

/**
 * Contests currently shown on the main lobby (section rows or featured rows).
 * Search should use this pool so results match what users see on the lobby home screen.
 */
export function collectDisplayedLobbyGames(input: CollectDisplayedLobbyGamesInput): LobbyGame[] {
  if (input.hasSectionLayout) {
    return dedupeByPickemId(input.sectionGames);
  }
  if (input.hasAnyFeaturedAssignments) {
    return dedupeByPickemId([
      ...input.heroCardGames,
      ...input.actionHeaderGames,
      ...input.popularSectionGames,
      ...input.recentlyPlayedSectionGames,
    ]);
  }
  return input.fallbackGames;
}
